import React from 'react';
interface LogoTileProps {
  title: string;
  href: string;
  external?: boolean;
  badge?: string;
}
function LogoTile({
  title,
  href,
  external = false,
  badge
}: LogoTileProps) {
  return <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="group relative bg-white rounded-lg border-2 border-gray-200 hover:border-orange hover:shadow-md transition-all duration-300 p-4 flex flex-col items-center justify-center min-h-[120px]" data-id="element-74">
      {badge && <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-bold text-white bg-orange rounded" data-id="element-75">
          {badge}
        </span>}

      {/* Placeholder Logo */}
      <div className="w-full h-12 bg-gray-200 rounded mb-2 flex items-center justify-center group-hover:bg-gray-300 transition-colors" data-id="element-76">
        <span className="text-gray-500 text-xs font-medium" data-id="element-77">Logo</span>
      </div>

      {/* Title */}
      <h3 className="text-xs font-semibold text-navy text-center group-hover:text-orange transition-colors leading-tight" data-id="element-78">
        {title}
      </h3>
    </a>;
}
export function FeaturedProductLines() {
  const productLines = [{
    title: 'Used Machine Inventory',
    href: '59m7/used-machines.html'
  }, {
    title: 'Breton',
    href: 'BretonMachineTools.html'
  }, {
    title: 'SPINNER',
    href: 'SpinnerMachineTools.html'
  }, {
    title: 'Bodor Laser',
    href: 'BodorLaserCutting.html'
  }, {
    title: 'Used AgieCharmilles & Mikron',
    href: 'GFMachiningSolutions.html'
  }, {
    title: 'Seibu America',
    href: 'https://seibu-america.com/',
    external: true,
    badge: 'NEW'
  }];
  return <section className="py-6 bg-gray-50 border-b border-gray-200" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-81">
          {productLines.map((product, index) => <LogoTile key={index} title={product.title} href={product.href} external={product.external} badge={product.badge} data-id="element-82" />)}
        </div>
      </div>
    </section>;
}